import { ICustomContextParams } from '../../types/ICustomContextParams';

export const initialState = {
  abGroup: '0',
};

export function customReducer(state: ICustomContextParams = initialState): ICustomContextParams {
  return state;
}
